import React, {useEffect, useState} from "react";
import CountUp from "react-countup";
import {DbUserService} from "app/services/db/dbUserService";
import {DashboardModuleProps} from "app/model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";
import {PcUserService} from "app/services/pc/pcUserService";
import {toast} from "react-toastify";
import {roundWithComma} from "app/utils/stringUtil";

export default function EquipmentStatus(props: Readonly<DashboardModuleProps>) {
  const [initLoad, setInitLoad] = useState<boolean>(true);
  const [headerData, setHeaderData] = useState<{nor?: number; eqf?: number; cmf?: number}>();
  const [cardData, setCardData] = useState<any>([]);

  useEffect(() => {
    async function initializeData() {
      try {
        const headerResponse = await PcUserService.getInstance().getUserInverterHeaderData();
        if (headerResponse && headerResponse?.resultCode === "Y") {
          if(headerResponse?.data) {
            setHeaderData(headerResponse.data);
          }
        } else {
          throw new Error("헤더 데이터를 가져올 수 없습니다.");
        }
        await getCardData();
      } catch (error) {
        toast.error("설비현황 데이터를 불러오는 중 오류가 발생했습니다.");
      } finally {
        setInitLoad(false);
      }
    }
    if (initLoad) {
      initializeData().catch(()=>{})
    }
  }, [initLoad]);

  async function getCardData() {
    const res = await DbUserService.getInstance().fetchInverterEfficiency(1);
    if (res && res?.status === 200 && res.data?.data?.contents) {
      let data = res.data.data.contents;
      if(data?.length > 3) {
        setCardData(data.slice(0,3))
      } else {
        setCardData(data)
      }
    } else {
      throw new Error("카드데이터를 불러올 수 없습니다.");
    }
  }

  function changeStatus (name: string) {
    switch(name) {
      case "0" :
        return <em className="st1">정상</em>
      case "1" :
          return <em className="st2">정지</em>
      case "2" :
          return <em className="st3">통신이상</em>
      default :
          return;
    }
  }
  return (
      <DashboardCard
          title="설비 현황"
          isConfigMode={props.isConfigMode ?? false}
          moreButtonVisible={true}
          moreButtonUrl="/pc/facility/status"
          dashboardConfig={props.dashboardConfig}
      >
        <div>
          <div className="n-flex">
            <div className="facility-status">
              <div>
                <span className="normal"><span className="sr-only">정상</span></span>
                <p>정상</p>
                <strong>{headerData?.nor ?? 0}</strong>
              </div>
              <div>
                <span className="stop"><span className="sr-only">정지</span></span>
                <p>정지</p>
                <strong>{headerData?.eqf ?? 0}</strong>
              </div>
              <div>
                <span className="error"><span className="sr-only">통신이상</span></span>
                <p>통신이상</p>
                <strong>{headerData?.cmf ?? 0}</strong>
              </div>
            </div>
          </div>
            {cardData && cardData.length > 0 ?
                <div className="facility-box-wrap">
                  {cardData.map((value: any, index:number) => (
                      <div className="facility-box" key={`${value.mgRsrcId}-${index}`}>
                        <div className="tit">
                          <span>{value.mgRsrcNm}</span>
                          {changeStatus(value.stsClNm)}
                        </div>
                        <div className="inner">
                          <div>
                            <span className="img"><span className="sr-only">인버터 이미지</span></span>
                            <p>
                              <strong>
                                {roundWithComma((value.mgRsrcCpct ?? 0),1)}
                              </strong>
                              kW
                            </p>
                          </div>
                          <div>
                            <div>
                              <span className="value-tit">입력</span>
                              <p><strong>{roundWithComma(value.invrInptPwr, 1)}</strong>kW</p>
                            </div>
                            <div>
                              <span className="value-tit">출력</span>
                              <p><strong>{roundWithComma(value.invrOtptPwr, 1)}</strong>kW</p>
                            </div>
                          </div>
                        </div>
                        <div className="value-txt">
                          <p>
                            {(value.invrInptPwr && value.invrInptPwr >= 1) ? (
                              <>
                                <strong>
                                  <CountUp
                                    end={value.invrOtptPwr / value.invrInptPwr * 100}
                                    duration={0.5}
                                  />
                                </strong>%
                              </>
                            ) : (
                              <strong>-</strong>
                            )}
                          </p>
                        </div>
                      </div>
                  ))
                  }
                </div>
                : (headerData && typeof headerData === "object" && Object.values(headerData).some(value => typeof value === "number" ? value !== 0 : value !== "-") ? (
                        <div className="facility-box-wrap">
                        <div className="facility-box">
                          <div className="tit">
                          </div>
                          <div className="inner" style={{display: "block"}}>
                            <div>
                              <span className="img"><span className="sr-only">인버터 이미지</span></span>
                            </div>
                          </div>
                          <div className="value-txt">
                            <p>
                              <strong>-</strong>
                            </p>
                          </div>
                        </div>
                        </div>
                    ) : (
                        <div style={{position: "absolute", top: "0", left:"0", right:"0", bottom:"0", display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center"}}>
                          <p className="mg20 ac" style={{padding:"0 1rem"}}>등록된 태양광 자원이 없거나, 금일 수집된 데이터가 없습니다.</p>
                        </div>
                    )
                )
            }
        </div>
      </DashboardCard>
  )
}